import { render, staticRenderFns } from "./dealForm.vue?vue&type=template&id=1ff42f35&scoped=true&"
import script from "./dealForm.vue?vue&type=script&lang=js&"
export * from "./dealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff42f35",
  null
  
)

export default component.exports